import type { MessageType } from "@lib/campaignMessageTypeConstants";
import { isPushType } from "@lib/campaignMessageTypeConstants";

import { getChannelForMessageType } from "./getChannelForMessageType";
import type { ContentOptimizationDuplicateChannelSelection } from "./types";

/** Whether a message item should be copied for the given duplicate-as-CO channel choice. */
export const messageItemMatchesDuplicateChannelSelection = (
  messageType: MessageType | null | undefined,
  duplicateChannelSelection: ContentOptimizationDuplicateChannelSelection
): boolean => {
  if (isPushType(duplicateChannelSelection)) {
    return messageType === duplicateChannelSelection;
  }

  return getChannelForMessageType(messageType) === duplicateChannelSelection;
};
